import React from 'react';

import './index.module.less';

import { IProps } from './index.d';

import Toast from '@widgets/Toast';
interface IState {
  currentValue: number;
  controlDisplayTips: boolean;
}

class Slider extends React.Component <IProps, IState> {
  sliderBlock: React.RefObject<HTMLDivElement> = React.createRef();
  sliderTip: React.RefObject<HTMLDivElement> = React.createRef();
  slider: React.RefObject<HTMLDivElement> = React.createRef();
  clientWidth: number;
  startX: number;
  timer: any;
  constructor(props: IProps) {
    super(props);
    this.state = {
      currentValue: props.value || 0,
      controlDisplayTips: false
    }
    this.startX = 0;
    this.clientWidth = document.documentElement.clientWidth;
  }

  componentWillReceiveProps(nextProps: any): void {
    if(this.props.value!== nextProps.value) {
      this.changeCurrenValue(nextProps.value);
    }
  }

  clickSliderDot = (event: any) => {
    const key = (event.target as HTMLDivElement).getAttribute('data-value') || '';
    const { onChange } = this.props;
    onChange && onChange(Number(key));
  }

  //渲染滑动条上的刻度
  renderMarks = (): JSX.Element[] | null => {
    const { max, min, showMarks, step } = this.props;
    const { currentValue } = this.state;
    if(!showMarks) {
      return null;
    }

    let Marks = null;
    const marksNums = (max - min) / step;
    if(marksNums > 1) { //如果需要显示滑动条分段，分段数大于两个时才需要显示
      const marksArr = Array.from(new Array(marksNums + 1).keys()).fill(marksNums * step);
      Marks = marksArr.map((item: any, index: number) => {
        return (
          <span
            key={ index }
            data-value={ index }
            styleName="slider-dot"
            onClick={ this.clickSliderDot }
            style={{
              left: Math.ceil(index / marksNums * 100) + '%',
              borderColor: index * step <= currentValue ? '#256EFF' : '#F7F8FA'
            }}
          />
        )
      });
     //需要手动加上终节点，并设置位置为99%(如果设置为100%则会超出滑动条右边界)
      // Marks.push(
      //   <span styleName="slider-dot" style={{ left: 99 + '%', borderColor: '#F7F8FA' }} />
      // )
    }
    return Marks;
  }

  touchStart = (e: React.TouchEvent): void => {
    if(this.props.disabled) {
      return;
    }
    //多手指时不触发事件
    if(e.touches.length >= 2) {
      return;
    }
    //单手指时正常触发滑动
    const { clientX } = e.touches[0];
      //设置滑动的初始位置
      this.startX = clientX;
    //需要显示提示状态时，需要先显示出提示状态
    if(this.props.showTip) {
      this.setState({ controlDisplayTips: true });
    }
    //点击或滑动时需要将滑块变大时 设置滑块大小
    if(this.props.blockSizeChange) {
      (this.sliderBlock.current as HTMLDivElement).style.width = '30px';
      (this.sliderBlock.current as HTMLDivElement).style.height = '30px';
    }
  }

  touchMove = (e: React.TouchEvent): void => {
    if(this.props.disabled) {
      return;
    }
    const { clientX } = e.touches[0];
    const { max, min, step = 1 } = this.props;
    //横向滑动的值
    const moveX = clientX - this.startX;
    const ratio = moveX / this.clientWidth;

    //双手指时不能滑动
    if(e.touches.length >= 2) {
      return;
    }

    let value = this.props.value + Math.round(ratio * (max - min) / step) * step;

    if(value > max && moveX > 0) {
      Toast.show({
        type: 'strip',
        title: '区域半径最大为1km'
      })
      value = max;
    } else if(moveX < 0 && value < min) {
      Toast.show({
        type: 'strip',
        title: '区域半径最小为100m'
      })
      value = min;
    }
    this.setState({
      currentValue: value
    });
  }


  changeCurrenValue = (value: any) => {
    this.setState({
      currentValue: value
    });
  }

  touchEnd = (): void => {
    if(this.props.disabled) {
      return;
    }
    //如果滑块被放大，停止时恢复原有大小
    if(this.props.blockSizeChange) {
      (this.sliderBlock.current as HTMLDivElement).style.width = '20px';
      (this.sliderBlock.current as HTMLDivElement).style.height = '20px';
    }

    this.startX = 0;
    //如果设置了滑动提示, 停止时需隐藏
    this.setState({ controlDisplayTips: false });
    const { onChange } = this.props;
    onChange && onChange(Math.ceil(this.state.currentValue));
  }

  render(): JSX.Element {
    const {
      max,
      min,
      sliderColor,
    } = this.props;
    const { currentValue, controlDisplayTips } = this.state;
    const leftPosition = currentValue / (max - min) * 100 > 99 ? 99 : currentValue / (max - min) * 100;

    return (
      <div styleName="slider" ref={ this.slider }>
        <div styleName="slider-inner"
          style={{ background: sliderColor || '', width: ((currentValue / max) * 100 + 1) + '%' }}
        />
        { this.renderMarks() }
        <div
          styleName="slider-block"
          ref={ this.sliderBlock }
          style={{ left: (leftPosition <= 0 ? -1 : leftPosition) + '%' }}
          onTouchStart={ this.touchStart }
          onTouchMove={ this.touchMove }
          onTouchEnd={ this.touchEnd }
        />
        {
          controlDisplayTips ? (
            <div
              ref={ this.sliderTip }
              styleName="slider-tip"
              className="flex flex-center"
              style={{ left: leftPosition + '%'}}
            >
              <div styleName="slider-tip-text" className="flex flex-center">{ Math.ceil(currentValue) }</div>
            </div>
          ) : null
        }
      </div>
    );
  }

  static defaultProps = {
    max: 100,
    min: 0,
    value: 0,
    step: 1,
    showMarks: false,
    markStep: 10,
    showTip: false,
    blockSizeChange: false,
    sliderColor: '#256EFF',
    blockColor: '#256EFF',
    disabled: false
  }
}

export default Slider;
